import { selectIsLoggedIn, updateLanguage } from 'containers/Login/loginSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { PATCH } from 'rest/request'
import { user } from 'rest/urls'

type Language = 'pl' | 'en'

const useLanguage = () => {
  const isLoginIn = useReduxSelector(selectIsLoggedIn)
  const dispatch = useReduxDispatch()
  const sendLanguage = async (language: Language) => {
    try {
      await PATCH(user, { body: { language } })
    } catch (error) { }
  }

  const changeLanguage = (language: Language) => {
    dispatch(updateLanguage(language))
    if (isLoginIn) {
      sendLanguage(language)
    }
  }

  return changeLanguage
}

export default useLanguage